export default class SearchModal {
    constructor() {
        this.modal = null;
        this.modalContent = null;
        this.isOpen = false;
        this.scrollPosition = 0;
        this.searchInput = null;
        // Don't auto-init, let renderer handle it
    }

    init() {
        // Find existing modal in DOM
        this.modal = document.querySelector('[data-search-modal="overlay"]');

        if (!this.modal) {
            return;
        }

        this.modalContent = this.modal.querySelector('[data-search-modal="content"]');
        this.searchInput = this.modal.querySelector('#search-input');

        this.bindEvents();
    }

    bindEvents() {
        // Listen for search trigger clicks
        document.addEventListener('click', (e) => {
            const trigger = e.target.closest('[data-search-modal="trigger"]');
            if (trigger) {
                e.preventDefault();
                this.open();
            }
        });

        // Close modal on backdrop click
        this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal || e.target.matches('[data-search-modal="backdrop"]')) {
                this.close();
            }
        });

        // Close modal on close button click
        this.modal.addEventListener('click', (e) => {
            if (e.target.closest('[data-search-modal="close"]')) {
                this.close();
            }
        });

        // Close modal on escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.close();
            }
        });

        // Handle form submission within modal
        this.modal.addEventListener('submit', (e) => {
            const form = e.target.closest('[data-search-modal="form"]');
            if (form) {
                const searchInput = form.querySelector('input[name="s"]');
                if (searchInput && !searchInput.value.trim()) {
                    e.preventDefault();
                    searchInput.focus();
                }
            }
        });
    }

    open() {
        if (this.isOpen || !this.modal) return;

        this.isOpen = true;

        // Show modal with animation
        this.modal.classList.remove('pointer-events-none');
        requestAnimationFrame(() => {
            this.modal.classList.remove('opacity-0');
            this.modal.classList.add('opacity-100');
            this.modalContent.classList.remove('scale-95');
            this.modalContent.classList.add('scale-100');
        });

        // Focus search input
        if (this.searchInput) {
            setTimeout(() => this.searchInput.focus(), 100);
        }

        // Prevent body scroll
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.style.width = '100%';
    }

    close() {
        if (!this.isOpen || !this.modal) return;

        this.isOpen = false;

        // Hide modal with animation
        this.modal.classList.add('opacity-0');
        this.modal.classList.remove('opacity-100');
        this.modalContent.classList.add('scale-95');
        this.modalContent.classList.remove('scale-100');

        // Add pointer-events-none after animation
        setTimeout(() => {
            this.modal.classList.add('pointer-events-none');
        }, 500);

        // Restore body scroll
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, this.scrollPosition);
    }
}